import { quoteTrainingBusinessText } from "i18n/trainingbusiness";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const QuoteTrainingBusiness = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = quoteTrainingBusinessText[lang];
  const navigate = useNavigate();

  return (
    <section className="bg-black py-16 px-6">
      <div className=" mx-auto border border-white/70 px-6 md:px-16 py-14 md:py-20 text-center">
        {/* Main Quote */}
        <div className="max-w-5xl mx-auto">
          <h2
            className="  text-white font-semibold leading-tight
                       text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-[Crimson] "
          >
            {t.title}
          </h2>

          <p
            className="mt-8 text-white/90
                      text-base sm:text-lg md:text-xl
                      leading-relaxed max-w-3xl mx-auto"
          >
            {t.desc}
          </p>
          {/* <div className="mt-10">
            <button
              onClick={() => navigate("/contact")}
              className="px-8 py-3 border border-reddark text-white bg-reddark rounded-lg
                         uppercase tracking-wide text-sm
                         hover:bg-white hover:text-reddark hover:font-semibold transition-all duration-300"
            >
              {t.cta}
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default QuoteTrainingBusiness;
